import { environment } from './../../../../environments/environment';
import { Location } from '@angular/common';
import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { fuseAnimations } from '../../../core/animations';
import { Router, ActivatedRoute, NavigationEnd } from '../../../../../node_modules/@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as pbi from "powerbi-client";
import { NotificacionesService } from '../../../core/notificaciones/notificaciones.service';
import { ConstantesService } from '../../../core/constantes/constantes.service';
import { Observable } from 'rxjs/Observable';
import { ActivosService } from '../activos/activos.service';
import { Platform } from '@angular/cdk/platform';

@Component({
    selector: 'fuse-power-bi',
    templateUrl: './power-bi.component.html',
    styleUrls: ['./power-bi.component.scss'],
    animations: fuseAnimations
})
export class PowerBiComponent implements OnInit, OnDestroy {
  private groupId: string;
  url: string;
  descripcion: string;
  reportId: string;

  navigationSubscription;
  idActivo: number;
  idDashboard: number;
  isMobile: boolean;

  @ViewChild('reportContainer') reportContainer: ElementRef;

  constructor(
    private http: HttpClient,
    private notificaciones: NotificacionesService,
    private constantes: ConstantesService,
    private activosService: ActivosService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private platform: Platform
  ) {
      // FIXME
      // Group Id
      this.groupId = environment.powerbi.groupId;
      // Report Id
      //this.reportId = JSON.parse(sessionStorage.getItem("usuarioLogueado")).usuario.cliente.general_powerbi;
      this.reportId = this.route.snapshot.paramMap.get('url');
      // -- FIXME

      // this.url = this.route.snapshot.paramMap.get('url');
      this.descripcion = this.route.snapshot.paramMap.get('descripcion');
      this.idActivo = Number(this.route.snapshot.paramMap.get('idActivo'));
      this.idDashboard = Number(this.route.snapshot.paramMap.get('idDashboard'));

      // notify about the new activo
      this.activosService.setCurrentActivo(this.idActivo)

      this.navigationSubscription = this.router.events.subscribe((e: any) => {
        // If it is a NavigationEnd event re-initalise the component
        if (e instanceof NavigationEnd) {
          this.initialiseInvites()
        }
      });

      if ( this.platform.ANDROID || this.platform.IOS )
      {
          this.isMobile = true;
      }

      // this.url = 'https://app.powerbi.com/view?r=eyJrIjoiZjIxZGY3MjktODk4NS00MGE0LTliMGQtNzY4NGVlNzI3MWFhIiwidCI6IjQzNTBlY2U4LThmM2ItNGI3OS04YWM3LWNhM2QyNDAxMzRiOCIsImMiOjh9';
      location.go('/power-bi');
  }

  ngOnInit() {
    if (this.reportId) {
      // First off, we need an access token for the power bi pro user
      this.getAccessToken().subscribe((res: { "access_token": string }) => {
        const { access_token } = res
        // Then, we need an embed token in order to embed in our app the report provided
        this.getEmbedToken(access_token).subscribe((res: { "token": string }) => {
          const { token } = res

          // Finally, we render the report
          this.showReport(token)
        }, err => {
          if (err.status === 404) {
            this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.PowerBi.NOEncontrado)
          } else {
            console.error(err.message);
            this.notificaciones.mostrarAviso(err.message)
          }
        })
      }, err => {
        console.error(err);
        this.notificaciones.mostrarAviso(err.error.error_description)
      });
    } else {
      this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.PowerBi.NOEncontrado)
    }
  }

  getAccessToken(): Observable<Object> {
    return this.http.get(environment.urlBase + 'getAccessToken', this.constantes.httpOptions);
  }

  getEmbedToken(accessToken: string): Observable<Object> {
    return this.http.get(environment.urlBase + `getEmbedToken/${accessToken}/${this.reportId}` , this.constantes.httpOptions);
  }

  initialiseInvites() {
      // Set default values and re-fetch any data you need.
      // this.url = this.route.snapshot.paramMap.get('url');

      // update the required variables
      this.reportId = this.route.snapshot.paramMap.get('url');
      this.descripcion = this.route.snapshot.paramMap.get('descripcion');
      this.idActivo = Number(this.route.snapshot.paramMap.get('idActivo'));
      this.idDashboard = Number(this.route.snapshot.paramMap.get('idDashboard'));

      // start the process again
      this.ngOnInit()
  }

  showReport(embedToken: string) {
    const config = {
      type: "report",
      accessToken: embedToken,
      embedUrl: "https://app.powerbi.com/reportEmbed",
      tokenType: pbi.models.TokenType.Embed,
      id: this.reportId,
      permissions: pbi.models.Permissions.All,
      settings: {
        layoutType: this.isMobile ? pbi.models.LayoutType.MobilePortrait : pbi.models.LayoutType.Master,
        localeSettings: {
          language: "en",
          formatLocale: "es"
        }
      }
    };

    // Grab the reference to the div HTML element that will host the report.
    const reportContainer = this.reportContainer.nativeElement;

    // Embed the report and display it within the div container.
    const powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
    
    // reset the container, if any previous report was set
    powerbi.reset(reportContainer)

    // embed the container
    powerbi.embed(reportContainer, config);
  }

  ngOnDestroy() {
    // avoid memory leaks here by cleaning up after ourselves. If we
    // don't then we will continue to run our initialiseInvites()
    // method on every navigationEnd event.
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/power-bi/power-bi.component.ts